export const DEFAULT_MAX_X_OFFSET_MULTIPLIER = 0.6;
export const DEFAULT_SPAN_MS = 200;
